import React from 'react';
import { Accordion, AccordionItem } from '@chakra-ui/react';
const VerticalAccordion = (props) => (React.createElement(Accordion, { variant: "white", defaultIndex: props.expanded ? 0 : undefined, allowToggle: true },
    React.createElement(AccordionItem, null, props.children)));
export default VerticalAccordion;
